import React from "react";
import HeroVideo from "../components/HeroVideo";
import FeatureIcons from "../components/FeatureIcons";
import StatsSection from "../components/StatsSection";
import ServicesGrid from "../components/ServicesGrid";
import ProcessSection from "../components/ProcessSection";
import AboutSection from "../components/AboutSection";
import Testimonials from "../components/Testimonials";
import CTASection from "../components/CTASection";

export default function Home() {
  return (
    <>
      <HeroVideo />
      <div className="bg-[#0a0a0a] py-10 flex justify-center">
        <a
          href="/arbot/basvuru.php"
          className="group inline-flex items-center justify-center gap-3 sm:gap-4 mx-4 px-6 sm:px-10 py-5 bg-[#D4AF37] border border-[#D4AF37] text-[#0a0a0a] text-center text-[11px] sm:text-[12px] tracking-[0.15em] sm:tracking-[0.25em] font-semibold shadow-[0_0_24px_rgba(212,175,55,0.25)] hover:bg-[#E6C65C] hover:border-[#E6C65C] transition-colors duration-300"
        >
          <span>
            <strong className="font-bold">ÜCRETSİZ</strong> Teşvik &amp; Hibe Ön Değerlendirme
          </span>
          <span className="shrink-0 w-5 h-px bg-[#0a0a0a] group-hover:w-8 transition-all duration-300" />
        </a>
      </div>
      <FeatureIcons />
      <StatsSection />
      <ServicesGrid />
      <ProcessSection />
      <AboutSection />
      <Testimonials />
      <CTASection />
    </>
  );
}
